import { api } from "@/builders/axios";
import { ActivateOrDeactivateOrganizationData } from "@/builders/types/organization";

export function activate_or_deactivate(
  variables: ActivateOrDeactivateOrganizationData
) {
  const { link, ...data } = variables;
  return api
    .post<{
      message: string;
    }>(`/organizations/${link}/activate-or-deactivate`, data)
    .then((data) => data);
}
